import { render, staticRenderFns } from "./ModeViewAlternate.vue?vue&type=template&id=08c54f34&"
import script from "./ModeViewAlternate.vue?vue&type=script&lang=js&"
export * from "./ModeViewAlternate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports